module.exports = __webpack_public_path__ + "static/media/image1.285c0940.jpg";